import {
  ArrowLeftFromLine,
  BookUser,
  Building2,
  CircleHelp,
  Clipboard,
  Home,
  IdCard,
  PlusCircle,
  ShipIcon,
  ShipWheel,
  Trash2,
  Trophy,
  User,
  Users,
  Wallet,
  Bell,
  ArrowLeftRight,
  Medal,
} from "lucide-react";
import { DashboardConfig } from "./dashboard";

const sharedMenuItems = {
  home: {
    name: "Inicio",
    href: "/dashboard/home",
    icon: Home,
  },
  competitions: {
    name: "Competencia",
    href: "/dashboard/competitions",
    icon: Trophy,
  },
  institutions: {
    name: "Barras pesqueras",
    href: "/dashboard/institutions",
    icon: Building2,
  },
  teams: {
    name: "Equipos",
    href: "/dashboard/teams",
    icon: BookUser,
  },
  teamMembers: {
    name: "Participantes",
    href: "/dashboard/team-members",
    icon: Users,
  },
  boats: {
    name: "Embarcaciones",
    href: "/dashboard/boats",
    icon: ShipIcon,
  },
  payments: {
    name: "Pagos",
    href: "/dashboard/payments",
    icon: Wallet,
  },
  users: {
    name: "Usuarios",
    href: "/dashboard/users",
    icon: User,
  },
  helpDesk: {
    name: "Solicitudes de ayuda",
    href: "/dashboard/help-desk",
    icon: Clipboard,
  },
  notifications: {
    name: "Notificaciones",
    href: "/dashboard/notifications",
    icon: Bell,
  },
  teamNotifications: {
    name: "Notificaciones",
    href: "/dashboard/notifications/teams",
    icon: Bell,
  },
  createTeam: {
    name: "Crear Equipo",
    href: "/dashboard/create-team",
    icon: PlusCircle,
  },
  myTeam: {
    name: "Equipo",
    href: "/dashboard/my-team",
    icon: ShipWheel,
  },
  myBoat: {
    name: "Embarcación",
    href: "/dashboard/my-boat",
    icon: ShipIcon,
  },
  myMembers: {
    name: "Miembros",
    href: "/dashboard/my-members",
    icon: Users,
  },
  activateAccount: {
    name: "Activar Cuenta",
    href: "/dashboard/activate-account",
    icon: IdCard,
  },
  help: {
    name: "Ayuda",
    href: "/dashboard/help",
    icon: CircleHelp,
  },
  leaveTeam: {
    name: "Salir del Equipo",
    href: "/dashboard/leave-team",
    icon: ArrowLeftFromLine,
  },
  deleteTeam: {
    name: "Eliminar Equipo",
    href: "/dashboard/delete-team",
    icon: Trash2,
  },
  pendingTransfers: {
    name: "Transferencias a confirmar",
    href: "/dashboard/pending-transfers",
    icon: ArrowLeftRight,
  },
  results: {
    name: "Resultados",
    href: "/dashboard/results",
    icon: Medal,
  },
};

export const dashboardConfigs: DashboardConfig = {
  1: {
    active: [
      sharedMenuItems.home,
      sharedMenuItems.competitions,
      sharedMenuItems.institutions,
      sharedMenuItems.teams,
      sharedMenuItems.teamMembers,
      sharedMenuItems.boats,
      sharedMenuItems.payments,
      sharedMenuItems.pendingTransfers,
      sharedMenuItems.users,
      sharedMenuItems.helpDesk,
      sharedMenuItems.notifications,
    ],
  },
  2: {
    active: [
      sharedMenuItems.home,
      sharedMenuItems.competitions,
      sharedMenuItems.institutions,
      sharedMenuItems.teams,
      sharedMenuItems.teamMembers,
      sharedMenuItems.boats,
      sharedMenuItems.payments,
      sharedMenuItems.pendingTransfers,
      sharedMenuItems.users,
      sharedMenuItems.helpDesk,
      sharedMenuItems.teamNotifications,
    ],
  },
  3: {
    active: [
      sharedMenuItems.home,
      sharedMenuItems.createTeam,
      sharedMenuItems.myTeam,
      sharedMenuItems.myBoat,
      sharedMenuItems.myMembers,
      sharedMenuItems.competitions,
      sharedMenuItems.results,
      sharedMenuItems.deleteTeam,
      sharedMenuItems.help,
    ],
    registered: [
      sharedMenuItems.home,
      sharedMenuItems.activateAccount,
      sharedMenuItems.help,
    ],
  },
  4: {
    active: [
      sharedMenuItems.home,
      sharedMenuItems.myTeam,
      sharedMenuItems.myBoat,
      sharedMenuItems.myMembers,
      sharedMenuItems.competitions,
      sharedMenuItems.results,
      sharedMenuItems.leaveTeam,
      sharedMenuItems.help,
    ],
    registered: [
      sharedMenuItems.home,
      sharedMenuItems.activateAccount,
      sharedMenuItems.help,
    ],
  },
};
